const state = {
	roles:null,
	authUser:null
}
const mutations  = {
	SET_AUTH_USER(state,userObj){
		state.authUser = userObj
	},
	SET_USER_ROLE(state,userRole){
		state.roles = userRole		
	}
}
const actions = {
	setUserObject :({commit},userObj) => {
		commit('SET_AUTH_USER',userObj)
	},
	setUserRoles :({commit},userRole) => {
		commit('SET_USER_ROLE',userRole)
	}
}
export default {
	state, mutations, actions
} 


// WEBPACK FOOTER //
// ./src/user/userStore.js